import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import Button, { ButtonStyle } from "components/Button";
import { isNotEmpty } from "utils/validate";
import * as styles from "./styles.module.scss";
export var RadioInputViewType;
(function (RadioInputViewType) {
    RadioInputViewType["BUTTON"] = "BUTTON";
    RadioInputViewType["RADIO"] = "RADIO";
})(RadioInputViewType || (RadioInputViewType = {}));
const RadioInputGroup = ({ className = "", readonly = false, items = [], value, isPageSection, onBlur, onChange, viewType = RadioInputViewType.BUTTON, initialFocusedTabIndex, ...restProps }) => {
    const buttonsRef = useRef(null);
    useEffect(() => {
        if (!!buttonsRef?.current && isNotEmpty(initialFocusedTabIndex)) {
            const elements = buttonsRef.current?.querySelectorAll("button");
            if (elements[initialFocusedTabIndex ?? 0]) {
                elements[initialFocusedTabIndex ?? 0].focus();
            }
        }
    }, [initialFocusedTabIndex]);
    return (React.createElement("div", { className: classNames(styles.radioInput, className), ref: buttonsRef }, items.map(({ value: itemValue, ...props }) => (React.createElement(Button, { key: itemValue, classes: {
            root: classNames(styles.item, {
                [styles.radio]: viewType === RadioInputViewType.RADIO,
                [styles.emptyLabel]: !props.label,
                [styles.active]: value === itemValue,
                [styles.isPageSection]: isPageSection,
                [styles.readonly]: readonly,
            }, props.className),
        }, onClick: () => {
            if (value !== itemValue) {
                onChange(itemValue);
                onBlur && onBlur();
            }
        }, style: ButtonStyle.Link, disabled: readonly, showTooltipIfDisabled: true, ...props, ...restProps })))));
};
export default RadioInputGroup;
